const initialState = {
    dataapprove: [],
    datareject: [],
    datahold: []

};

const AViewHospitalReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_Approve_SUCCESS':
            return { ...state, dataapprove: action.payload };
        case 'FETCH_Reject_SUCCESS':
            return { ...state, datareject: action.payload };
        case 'FETCH_Hold_SUCCESS':
            return { ...state, datahold: action.payload };



        default:
            return state;
    }
};

export default AViewHospitalReducers;

